import TouchZoneBase from '../framework/src/modules/TouchZoneBase';
import SymbolFactory from './Symbols/SymbolFactory';
import SystemConfig from '../framework/src/system/SystemConfig';
import PixiLayers from '../framework/src/engine/pixi/PixiLayers';
import Wallet from '../framework/src/wallet/Wallet';
import { inject, injectable } from 'inversify';
import GameSlotsCore from '../framework/src/game/GameSlotsCore';
import SERVICE_IDENTIFIER from '../framework/src/constants/identifiers';
import IInfoPages from '../framework/src/engine/IInfoPages';
import { getSprite, removeSprite } from '../framework/src/modules/Sprite';
import { EASE, getTween } from '../framework/src/modules/Tween';
import * as PIXI from "pixi.js-legacy";

@injectable()
export default class TouchZone extends TouchZoneBase {
    infoPages: IInfoPages;

    winCatorFrame: Array<PIXI.Sprite>;

    creditBet: number;

    tableSpriteArray: Array<string>;
    numbersSpriteArray: Array<string>;
    differentSymbol: Array<string>;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineAppLayers) layers: PixiLayers,
        @inject(SERVICE_IDENTIFIER.GameCore) gameCore: GameSlotsCore,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.EngineAppSymbols) symbols: SymbolFactory,
        @inject(SERVICE_IDENTIFIER.Gameset) gameset: any,
        @inject(SERVICE_IDENTIFIER.InfoPages) infoPages: IInfoPages
    ) {
        let smallLayers = {
            "winFactors": layers.getLayer("winFactors"),
            "touchZone":layers.getLayer("touchZone")
        }
        
        super(
            config,
            smallLayers,//.getAllLayers(),
            gameCore.slots,
            wallet,
            symbols,
            gameset
        );
        this.infoPages = infoPages;

        this.tableSpriteArray = ['table3lines.png', 'table4lines.png'];
        this.numbersSpriteArray = ['3x4x5x.png', '2x3x4x5x.png'];
        this.differentSymbol = ['symbol_Woman', 'symbol_Viking'];
    }

    /**
     *   gameset['game']['layers'][
     *     'black',    - black layer to darken other symbols when clicked
     *      'touchZone' - zones are added here
     *   ];
     *   gameset['game']['symbolModel']['touchZone']: {
     *       width :    - width of the touch zone, center aligned with the symbol
     *       height :   - height of the touch zone, center aligned with the symbol
     *       reels :    - array of the LENGTH defined by the reel COLUMNS COUNT, values [left|right], sets to what side is the frame shifted
     *       table :    - name of the winFactor frame image
     *       numbers :  - name of the winFactor numbers image
     *       font :     - name of the font used
     *       factors :  - amount of non-zero factors
     *   }
     *
     *  HOW TO USE TOUCHZONE:
     *  1. Set all gameset fields ^^ in gameset.js
     *  2. Create layers touchZone and winFactors and add them to gameset
     *  3. Rewrite drawFrame() function. use shiftSprite to position elements (don't forget both orientations!).
     *  4. Access elements using:
     *          -   this.winFactorFrame
     *          -   this.winFactorNumbers
     *          -   this.winFactorSprite
     *          -   this.factorOnSymbols[]
     *  5. When you start spinning and when the round ends use zonesOn(), zonesOff() to disable winFactors during spinning
     *
     *  6. For all those who will come after to fix this i am sorry, may the clean code gods be with you
     *
     */

    /**
     * @override
     * @params symbol - one of the resSymbols that was clicked on, data type is Sprite
     *         orientation - to what side you should shift the frame, values "left" or "right"
     */
    drawFrame(symbol: any, orientation: string) {
        if (!this.infoPages.isOpen()) {
            if (this.winFactorFrame !== undefined) {
                // because they are defined in base they need to be cleaned manualy
                this.factorOnSymbols.length = 0;
                this.winFactorFrame.removeChildren();
                this.winFactorNumbers.removeChildren();
                this.layers.winFactors.removeChildren();
            }

            // @ts-ignore
            this.layers.winFactors.alpha = 1;
            this.layers.winFactors.visible = true;            

            this.layers.winFactors.addChild(
                this.drawTable( symbol.name, symbol.x, symbol.y , orientation)
            );            
        }
    }

    setBitmapText(): PIXI.BitmapText {
        // creates a bitmap text and setit's style and returns it
        let style: PIXI.IBitmapTextStyle = {
            fontName: "font_wintable",
            fontSize: 80,
            align: "center",
            tint: 0xFFFFFF,
            letterSpacing: 0,
            maxWidth: 1280
        };
        return new PIXI.BitmapText('', style);
    }

    drawTable(symbolName:string, symbolPosX:number, symbolPosY:number, orientation: string ): PIXI.Sprite {
        // draw factor numbers depending on bet credit and multiplier        

        let factors = this.getSymbolFactor(symbolName).factors.filter(
            (f) => f > 0
        );

        if (symbolName === 'symbol_Wild' || symbolName === 'symbol_Scatter')
            factors = [0, 0, 0];

        let x = 0;
        let y = 1;
        let yOffset = 48;

        let tableOffsetX = 110; // if orientation right add 100 to table Y positon
        let numbersOffsetX = 30; // position of numbers picture position

        if (orientation === 'left') {
            x = 1;
            tableOffsetX = -110;
            numbersOffsetX = -45;
        }

        let indexOfImage = 0; // index of array of images

        if (factors.length > 3) { 
            y = 0;
            yOffset = 51;
            indexOfImage = 1;
        }

        this.winFactorFrame = getSprite( this.tableSpriteArray[indexOfImage], symbolPosX + tableOffsetX, symbolPosY );
        this.winFactorFrame.name = "Touch Zone Table Img." + this.tableSpriteArray[indexOfImage];
        
        this.winFactorSprite = getSprite( symbolName + '.png', tableOffsetX * -1, 0 );
        this.winFactorSprite.name = "Touch Zone Symbol " + symbolName;        

        this.winFactorNumbers = getSprite( this.numbersSpriteArray[indexOfImage], numbersOffsetX, 0 );
        this.winFactorNumbers.name = "Touch Zone Factor Numbers Img." + this.numbersSpriteArray[indexOfImage];

        // position of factor numbers [x position left, x position right ]
        let posX = [190, -90];
        // position of factor numbers with 4 lines and 3 lines
        let posY = [12, -18];

        for (let i = factors.length - 1; i > -1; i--) {
            
            let factor = this.setBitmapText();
            let tmpTxt = (factors[i] * this.wallet.getCreditBet()).toString();
            factor.text = this.insertSpaces(tmpTxt);
            factor.name = "Touch Zone Factor."+i+", Value."+factors[i];

            factor.position.set(posX[x], posY[y] - yOffset * i);
            factor.pivot.set(factor.width, 0);
            this.factorOnSymbols.push(factor);            
        }

        this.winFactorFrame.addChild(
            this.winFactorSprite,
            this.winFactorNumbers,
            ...this.factorOnSymbols
        );

        return this.winFactorFrame;
    }

    /*
     * inserts spaces in to the score text "1000" ~> "1 000"
     */
    insertSpaces(str: string): string {
        let spaceIndex = 3;

        while (spaceIndex < str.length) {
            str = str.slice(-str.length, -spaceIndex) + " " + str.slice(-spaceIndex);
            spaceIndex += 4;
        }
        return str;
    }

    /**
     * @override
     */
    onPointerDown() {}

    /**
     * @override
     */
    onPointerUp() {}

    hide() {
        getTween(this.layers.winFactors, { alpha: 0 }, 250, EASE.LINEAR);
        this.layers.winFactors.visible = false;
        
        for (let i = this.factorOnSymbols.length - 1; i >= 0; i--) {
            this.factorOnSymbols[i].destroy({children:true, baseTexture:true});
        }
        this.factorOnSymbols.length = 0;

        if (this.winFactorFrame !== undefined) {
            // because they are defined in base they need to be cleaned manualy
                    
            this.layers.winFactors.removeChildren();

            this.winFactorSprite.destroy({children:true, baseTexture:true});
            this.winFactorNumbers.destroy({children:true, baseTexture:true});
            this.winFactorFrame.destroy({children:true, baseTexture:true});
            
/*
            this.winFactorSprite.removeChildren();
            this.winFactorNumbers.removeChildren();
            this.winFactorFrame.removeChildren();    
*/
            this.winFactorNumbers = undefined;
            this.winFactorFrame = undefined;
        }
    }

    initWinFrames() {}
}
